import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MyTasksService } from 'dm-src/app/modules/my-tasks/my-tasks.service';
import { BehaviorSubject } from 'rxjs';
import { LatLng, ModalService } from 'shared';

@Component({
    selector: 'app-location-check-modal',
    templateUrl: './location-check-modal.component.html',
    styleUrls: ['./location-check-modal.component.scss'],
})
export class LocationCheckModalComponent implements OnInit {
    safeUrl: SafeResourceUrl;
    url: string;
    center: google.maps.LatLngLiteral = { lat: 40.73061, lng: -73.935242 };
    infoWindow = new google.maps.InfoWindow({
        content: 'Cím lekérése...',
    });

    geocoder = new google.maps.Geocoder();
    address: string;

    zoom = 15;
    markers = [{ lat: 40.73061, lng: -73.935242 }];

    mapOptions: google.maps.MapOptions = {
        mapTypeId: 'roadmap', // 'satellite', 'hybrid', 'terrain' stb.
        disableDefaultUI: false, // Ha true, elrejti az alapértelmezett UI elemeket
        zoomControl: true, // Nagyítási gombok
        scrollwheel: true, // Görgetéssel zoomolás engedélyezése
        disableDoubleClickZoom: false, // Dupla kattintással zoomolás tiltása
        maxZoom: 40, // Maximális zoom szint
        minZoom: 5, // Minimális zoom szint
        styles: [
            // Egyéni térképstílus (opcionális)
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{ color: '#blue' }],
            },
        ],
    };

    constructor(
        private _modalService: ModalService,
        private _myTasksService: MyTasksService,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {
        this._myTasksService.currentPosition.subscribe((position) => {
            if (position) {
                this.center = { lat: position.lat, lng: position.lng };
                this.markers = [{ lat: position.lat, lng: position.lng }];
                const latlng = { lat: position.lat, lng: position.lng };

                this.geocoder.geocode({ location: latlng }, (results, status) => {
                    if (status === 'OK' && results[0]) {
                        console.log('Cím:', results[0].formatted_address);
                        this.address = results[0].formatted_address;
                    } else {
                        console.error('Geokódolás sikertelen:', status);
                    }
                });
            }
        });
    }

    public acceptLocation(): void {
        this._myTasksService.isCurrentPositionAccepted.next(true);
        this.closeModal();
    }

    public closeModal(): void {
        this._myTasksService.isCurrentPositionAccepted.next(false);
        this._modalService.setModalVisibility(false, 'location-check-modal');
    }
}
